import { useSelector } from "react-redux";
import { TRIGGER_TYPES } from "constants/flowDesigner";

const useCheckTriggersDuplicate = () => {
  const { flowTriggers } = useSelector((store) => store?.designer?.triggers);

  const checkIfTriggerDuplicate = (type) => {
    if (flowTriggers?.length) {
      const isExist = flowTriggers.find(
        (trigger) => trigger.type === type && trigger.type !== TRIGGER_TYPES.SCHEDULE
      );
      if (isExist) {
        return true;
      }
    }
    return false;
  };

  return { checkIfTriggerDuplicate };
};

export default useCheckTriggersDuplicate;
